// Company statements supplied by the user on 6 October 2026.
// These describe the company's own position; they are not independent verification.
export const companyProfile = {
  overview: [
    'BEDA Healthcare Limited is a Tanzanian healthcare company established in 2022, specializing in the supply, distribution, installation, and maintenance of high-quality medical equipment, laboratory instruments, diagnostic devices, medical consumables, and healthcare solutions.',
    'Headquartered in Dar es Salaam, Tanzania, BEDA Healthcare is committed to strengthening healthcare delivery by providing innovative, reliable, and cost-effective medical technologies to both public and private healthcare institutions. Our mission is to improve patient outcomes by ensuring healthcare providers have access to world-class medical equipment and dependable technical support.',
    'Through strategic partnerships with internationally recognized manufacturers and suppliers, BEDA Healthcare delivers quality products that meet global healthcare standards while addressing the specific needs of healthcare facilities across Tanzania.',
  ],
  vision: 'To become Tanzania’s leading provider of innovative healthcare technologies and medical solutions, improving healthcare accessibility and quality throughout East Africa.',
  mission: 'To provide high-quality medical equipment, laboratory solutions, and professional technical services that enhance healthcare delivery through innovation, integrity, reliability, and customer satisfaction.',
  values: ['Integrity', 'Excellence', 'Innovation', 'Customer Focus', 'Professionalism', 'Accountability', 'Quality Assurance', 'Continuous Improvement'],
  industries: ['Government Hospitals', 'Regional Referral Hospitals', 'District Hospitals', 'Private Hospitals', 'Health Centres', 'Clinics', 'Medical Laboratories', 'Universities', 'Research Institutions', 'NGOs', 'International Organizations', 'Public Health Programs'],
  whyChoose: ['Experienced healthcare solutions provider', 'Reliable sourcing from reputable global manufacturers', 'Competitive pricing', 'Professional technical support', 'Fast delivery and installation', 'Comprehensive after-sales service', 'Commitment to quality and compliance', 'Customer-centered approach'],
  quality: 'At BEDA Healthcare Limited, quality is at the heart of everything we do. We work with internationally recognized manufacturers whose products comply with applicable international standards. Our commitment extends beyond supplying equipment—we provide dependable technical support, training, and maintenance services to ensure long-term performance and customer satisfaction.',
  partnerships: 'BEDA Healthcare collaborates with reputable international manufacturers, distributors, healthcare institutions, development partners, and government organizations to provide modern healthcare technologies that strengthen healthcare systems across Tanzania.',
  socialResponsibility: 'We believe quality healthcare should be accessible to all. BEDA Healthcare supports initiatives that improve healthcare delivery, strengthen laboratory capacity, enhance healthcare worker training, and contribute to community health development.',
  commitment: [
    'Our commitment is to deliver innovative healthcare solutions that improve diagnosis, treatment, and patient care while building lasting relationships based on trust, quality, and professional excellence.',
    'We continually invest in technology, technical expertise, and customer support to ensure our clients receive dependable healthcare solutions that meet both current and future healthcare needs.',
  ],
  tagline: 'Your satisfaction is our Need',
} as const;

export const profileServices = [
  {
    title: 'Medical Equipment Supply',
    path: '/solutions/medical-equipment/',
    items: ['Hospital equipment', 'Diagnostic imaging systems', 'Intensive Care Unit (ICU) equipment', 'Patient monitoring systems', 'Surgical equipment', 'Operating theatre equipment', 'Emergency medical equipment'],
  },
  {
    title: 'Laboratory Equipment',
    path: '/solutions/laboratory-equipment/',
    items: ['Clinical laboratory analyzers', 'Molecular diagnostic systems', 'PCR equipment', 'DNA/RNA sequencing systems', 'Laboratory consumables', 'Laboratory furniture and accessories'],
  },
  {
    title: 'Medical Consumables',
    path: '/solutions/consumables/',
    items: ['Diagnostic test kits', 'Laboratory reagents', 'Medical disposables', 'Infection prevention products', 'Personal Protective Equipment (PPE)'],
  },
  {
    title: 'Biomedical Engineering Services',
    path: '/services/biomedical-engineering/',
    items: ['Installation and commissioning', 'Preventive maintenance', 'Equipment calibration', 'Technical support', 'Repair and troubleshooting', 'User training'],
  },
  {
    title: 'Procurement & Consultancy',
    path: '/services/procurement-consultancy/',
    items: ['Medical equipment planning', 'Hospital equipment sourcing', 'Procurement support', 'Technical specifications development', 'Equipment evaluation'],
  },
];

// Past work experience supplied by the user on 7 October 2026.
// Names do not establish current contracts, endorsements or project outcomes.
export const pastOrganisations = [
  'UNICEF',
  'SolidarMed',
  'Goodhope Hospital',
  'Haydom Lutheran Hospital',
  'Good Samaritan Hospital',
  'JKCI',
  'Frelimo District Hospital',
  'Kibiti District Hospital',
  'Sinza Health Center',
  'Aga Khan Hospital',
  'NIMR',
  'TPHPA',
  'Simiyu Regional Referral Hospital',
  'Tumbi Referral Hospital',
  'MSD',
  'Igawilo District Hospital',
  'Moshi Memorial University',
] as const;
